<template>
  <div>
    <Breadcrumb />
    <el-card class="box-card mt-20">
      <div slot="header" class="clearfix">
        <span>编辑售后服务人员</span>
      </div>
      <el-form
        ref="salePersonForm"
        :model="salePersonInfo"
        :rules="rules"
        class="add-form"
        :label-position="labelPosition"
        label-width="140px"
      >
        <div class="add-form-item">
          <el-form-item label=" 区域：">
            <span>{{ salePersonInfo.typeName }}</span>
          </el-form-item>
        </div>
        <div class="add-form-item">
          <el-form-item label=" 登录名：">
            <span>{{ salePersonInfo.loginName }}</span>
          </el-form-item>
        </div>
        <div class="add-form-item">
          <el-form-item label="登录密码：" prop="loginPwd">
            <el-input
              v-model="salePersonInfo.loginPwd"
              type="password"
            ></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多输入25个字符</span>
        </div>
        <div class="add-form-item">
          <el-form-item label="姓名：" prop="realName">
            <el-input v-model="salePersonInfo.realName"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多输入25个字符</span>
        </div>
        <div class="add-form-item">
          <el-form-item label="工号：" prop="staffCode">
            <el-input v-model="salePersonInfo.staffCode"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多输入25个字符</span>
        </div>
        <div class="add-form-item">
          <el-form-item label="联系电话：" prop="linkPhone">
            <el-input v-model="salePersonInfo.linkPhone"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多输入25个字符</span>
        </div>
        <div class="add-form-item">
          <el-form-item label="状态：">
            <el-radio-group v-model="salePersonInfo.status">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <br />
        <el-form-item>
          <el-button type="primary" @click="submit">确定</el-button>
          <el-button @click="goBack">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      labelPosition: "left",
      roleOptions: [],
      salePersonInfo: {
        typeName: "",
        afterSalePersonId: "",
        loginName: "",
        loginPwd: "",
        realName: "",
        staffCode: "",
        linkPhone: "",
        status: ""
      },
      rules: {
        loginName: [
          {
            max: 25,
            message: "最多输入25个字符",
            trigger: "change"
          }
        ],
        loginPwd: [
          {
            max: 25,
            message: "最多输入25个字符",
            trigger: "change"
          }
        ],
        realName: [
          {
            max: 25,
            message: "最多输入25个字符",
            trigger: "change"
          }
        ],
        staffCode: [
          {
            max: 25,
            message: "最多输入25个字符",
            trigger: "change"
          }
        ],
        linkPhone: [
          {
            max: 25,
            message: "最多输入25个字符",
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getSalePersonById: function(id) {
      let _this = this;
      let param = {
        url: "/api/salePerson/getSalePersonInfoById",
        params: {
          afterSalePersonId: id
        }
      };

      _this.$store.dispatch("getSalePersonInfo", param).then(() => {
        _this.salePersonInfo =
          _this.$store.state.salePerson.salePersonData.salePersonInfo;
      });
    },
    submit() {
      let _this = this;
      _this.$refs.salePersonForm.validate(isPass => {
        if (isPass) {
          let param = {
            url: "/api/salePerson/updateSalePersonInfo",
            params: {
              afterSalePersonId: _this.salePersonInfo.afterSalePersonId,
              loginPwd: _this.salePersonInfo.loginPwd,
              realName: _this.salePersonInfo.realName,
              staffCode: _this.salePersonInfo.staffCode,
              linkPhone: _this.salePersonInfo.linkPhone,
              status: _this.salePersonInfo.status
            }
          };

          _this.$Api
            .post(param.url, param.params)
            .then(response => {
              if (response.status === 200) {
                _this.$message({
                  message: "售后人员信息维护成功",
                  type: "success"
                });
                this.$router.push({
                  name: "salesPersonIndex"
                });
              } else {
                _this.$message({
                  message: response.data.msg,
                  type: "error"
                });
              }
            })
            .catch(err => {});
        } else {
          _this.$message({
            message: "请完善售后人员信息!",
            type: "warning"
          });
        }
      });
    }
  },
  created() {
    let _this = this;
    let id = this.$route.params.afterSalePersonId;
    if (id !== null && id !== "" && id !== undefined) {
      _this.getSalePersonById(id);
    }
  }
};
</script>

<style lang="sass" scoped>
.add-form-item
  width: 700px
  display: flex
  .el-form-item
    width: 460px
  .validate
    height: 40px
    line-height: 40px
    font-size: 14px
    color: #E6A23C
</style>
